import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import axios from 'axios'

// https://redux-toolkit.js.org/rtk-query/api/createApi
export const api = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.NX_API_BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      // By default, if we have a token in the store, let's use that for authenticated requests
      // todo type root state
      let token = (getState() as any)?.auth?.token
      if (!token) {
        token = localStorage.getItem('homeviews_access_token')
      }

      if (token) {
        headers.set('Authorization', `Bearer ${token}`)
      }
      return headers
    },
  }),
  tagTypes: ['Auth', 'Reviews'],
  endpoints: () => ({}),
})

export const API_V2_BASE_URL = `${process.env.NX_API_BASE_URL_PREFIX}/api/v2`

const AxiosClient = axios.create({
  baseURL: process.env.NX_API_BASE_URL,
})

AxiosClient.interceptors.request.use(
  (config) => {
    const bearerToken = localStorage.getItem('homeviews_access_token')
    config.headers['Authorization'] = `Bearer ${bearerToken}`
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

export { AxiosClient }
